import { st, sym } from "rdflib";
import { vcard } from "../namespaces.js";
export function updatePhoneNumber(phoneNumberNode, newPhoneNumber, store) {
    const oldValue = store.any(phoneNumberNode, vcard("value"));
    const deletions = oldValue
        ? [st(phoneNumberNode, vcard("value"), oldValue, phoneNumberNode.doc())]
        : [];
    const insertions = [
        st(phoneNumberNode, vcard("value"), sym("tel:" + newPhoneNumber), phoneNumberNode.doc()),
    ];
    return {
        insertions,
        deletions,
        filesToCreate: [],
    };
}
//# sourceMappingURL=updatePhoneNumber.js.map